// extracted by mini-css-extract-plugin
export var menuItem = "C_vK d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "C_vL d_Z d_bz d_bP";
export var menuMainLink = "C_vM d_f0 d_dB";
export var menuLink = "C_vN d_f0 d_dB";
export var icon = "C_p9 d_bC d_bP";
export var divider = "C_vP d_bC d_bP";
export var sublinks = "C_vQ";
export var link = "C_mZ";
export var Link = "C_rQ q_rQ q_q2 q_rm";